import { Component, HostListener, OnInit, Output,EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TalentInsightsService } from 'src/app/_services/talent-insights.service';
import cjson from 'compressed-json';
import { Location } from '@angular/common';


@Component({
    selector: 'app-webbtree-company-filters',
    templateUrl: './webbtree-company-filters.component.html',
    styleUrls: ['./webbtree-company-filters.component.scss'],
    standalone: false
})
export class WebbtreeCompanyFiltersComponent implements OnInit {
 /**Industry typeahead lists */
  industry_typeaheads: any[] = [];
  /**Compny sizes typeahead lists */
  companysizes_typeaheads: any[] = [];
  /** Location typeahead lists */
  location_typeaheads: any[] = [];
  companiesList: any[] = [];
  companyBucketName: string = '';
  industrySelectedChips: string[] = [];
  companySizesSelectedChips: string[] = [];
  fortuneFilterClick: boolean = true;
  locationSelectedChips: string[] = [];
  searchValue: string;
 showScrollDiv:boolean = false;
 scrollTop = 0;
  customBtnStyles = {
  'background-color': '#fff',
  'color': '#2e93a1',
  'border':'1px solid #d9d9d9',
  'height':'30px',
  'width':'30px'
};
childStyles = {
  button: {
    'background-color': '#fff',
  'color': '#2e93a1',
  'border':'1px solid #d9d9d9',
  'height':'30px',
  'width':'30px'
  },
  label: {
    'padding-right':'0 0'
  },
  history : {
    'height':'30px',
    'width':'30px'
  },
  spinnerPosition: {
    'top': '7px',
    'right':'12%'
  },
  clearSearch: {
    'right':'38px'
  },
  searchinput: {
    'padding-right': '30px'
  }
};
  @Output() buttonClicked = new EventEmitter<boolean>();
  unicornFilterClick: boolean = false;
  @Input() totalCompanies;
  @Input() filter;
  subscriptions: Subscription[] = [];
  parentSubject: Subject<any> = new Subject();
filterSearchValue: string = '';
  @Output() filterInput: EventEmitter<any> = new EventEmitter();


  constructor(private CompanyInsightsService: CompanyInsightsService, public router: Router, private location: Location, private route: ActivatedRoute) {
    this.companyBucketName = 'Fortun500';
        if (!this.router.url.includes("filter=")) {
      this.setDataInLocalStorage(true);
    } else {
      const cacheRequest = localStorage.getItem(this.route.snapshot.queryParams.filter);
      const filterData = cjson.decompress(JSON.parse(cacheRequest));
      this.loadDataFromLocalStorage(filterData);
    }

    const statemanagementSub = this.location.subscribe((p) => {
      const filterKey = this.getFilterKeyFromUrl();
      if (filterKey) {
        const cached = localStorage.getItem(filterKey);
        const filterData = cjson.decompress(JSON.parse(cached));
      this.loadDataFromLocalStorage(filterData);
      }
      // const parsedUrl = this.router.parseUrl(p.url);
      // const localKey = parsedUrl.queryParams.filter;
      // const cacheRequest = localStorage.getItem(localKey);
      // const filterData = cjson.decompress(JSON.parse(cacheRequest));
      // this.loadDataFromLocalStorage(filterData);

    })
  }

  ngOnInit() {
    const filterMethodSubscription = this.CompanyInsightsService.fetchCompanyFilterData.subscribe((res)=> this.getCompanyListData(res))
      this.subscriptions.push(filterMethodSubscription);
  }
@HostListener('window:scroll', [])
onWindowScroll() {
    if (window.pageYOffset > 255) {
      this.showScrollDiv = true;
    } else {
      this.showScrollDiv = false;
    }
  }

  getFilterData(type, input) {
    const typeaheadObj = {
      startindex: 0,
      resultsize: 10,
      searchviaboolean: true,
      booleanquery: "*",
      industries: this.industrySelectedChips,
      locations: this.locationSelectedChips,
      companysizes: this.companySizesSelectedChips,
      input: this.filterSearchValue ? this.filterSearchValue : input
    }
    if (type == 'industry') {
      typeaheadObj['typeahead'] = 'typeahead_industry'
      this.CompanyInsightsService.getIndustryAggregates(typeaheadObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.industry_typeaheads = res.data.aggs;
        }
      })
    } else if (type == 'companysize') {
      typeaheadObj['typeahead'] = 'typeahead_companysize'
      this.CompanyInsightsService.getIndustryAggregates(typeaheadObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.companysizes_typeaheads = res.data.aggs;
        }
      })
    } else if (type == 'fortune500') {
      this.fortuneFilterClick = !this.fortuneFilterClick;
      const filterData = {
        industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips:[],
        companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips: [],
        locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips: [],
        fortune: this.fortuneFilterClick,
        unicorn: this.unicornFilterClick,
        search: this.searchValue
      }
            this.setDataInLocalStorage();

    this.CompanyInsightsService.setCompanyFilterData(filterData);
    } else if(type == 'location') {
      typeaheadObj['typeahead'] = 'typeahead_location'
      this.CompanyInsightsService.getIndustryAggregates(typeaheadObj).subscribe((res: any) => {
        if (res.status == "success") {
          this.location_typeaheads = res.data.aggs;
        }
      })
    } else if(type == 'unicorn') {
      this.unicornFilterClick = !this.unicornFilterClick;
      const filterData = {
        industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips:[],
        companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips: [],
        locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips: [],
        fortune: this.fortuneFilterClick,
        unicorn: this.unicornFilterClick,
        search: this.searchValue

      }
            this.setDataInLocalStorage();

    this.CompanyInsightsService.setCompanyFilterData(filterData);
    }
    // if(input == '') {
    //  this.parentSubject.next({status: 'searchClear'});

    // }


  }

  getInputSearch(event) {
    if (event.type == 'search') {
      this.filterSearchValue = event.searchValue;
      this.getFilterData(event.filterType, event.searchValue);
     }
    if (event.type == 'apply') {
      this.filterSearchValue = '';
      if (event.filterType == 'industry')
        this.industrySelectedChips = event.selectedValue;
      else if (event.filterType == 'companysize')
        this.companySizesSelectedChips = event.selectedValue;
      else if(event.filterType == 'location')
        this.locationSelectedChips = event.selectedValue;
        const filterData = {
          industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips:[],
          companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips: [],
          locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips: [],
          fortune: this.fortuneFilterClick,
          unicorn: this.unicornFilterClick,
          search: this.searchValue

        }
              this.setDataInLocalStorage();

      this.CompanyInsightsService.setCompanyFilterData(filterData);
    } if(event.type == 'reset') {
      this.filterSearchValue = '';
      if (event.filterType == 'industry')
      this.industrySelectedChips = [];
    else if (event.filterType == 'companysize')
      this.companySizesSelectedChips = [];
    else if(event.filterType == 'location')
      this.locationSelectedChips = [];
      const filterData = {
        industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips:[],
        companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips: [],
        locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips: [],
        fortune: this.fortuneFilterClick,
        unicorn: this.unicornFilterClick,
        search: this.searchValue


      }
            this.setDataInLocalStorage();

    this.CompanyInsightsService.setCompanyFilterData(filterData);
    }
  }

  getRecommendCompanies() {
    let payload = {
      startindex: 0,
      resultsize: 7,
      searchviaboolean: true,
      booleanquery: this.searchValue ? this.searchValue: '*',
      industries: this.industrySelectedChips,
      locations: this.locationSelectedChips,
      companysizes: this.companySizesSelectedChips,
      companybuckettypes: this.fortuneFilterClick == true ? ['Fortun500'] : null
    }
    this.CompanyInsightsService.getRecommendedcompanies(payload).subscribe((res: any) => {
      if (res.status == "success") {
        this.companiesList = res.data.results.map(c => ({ ...c, tags: c.tags ? c.tags.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) : [] }));
      }
    })
  }

  getCompanySearch(event) {
   this.searchValue = event.searchValue;
    this.fortuneFilterClick = false;
    this.unicornFilterClick = false;
    this.industrySelectedChips = [];
    this.companySizesSelectedChips = [];
    this.locationSelectedChips = [];
    const filterData = {
      industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips:[],
      companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips: [],
      locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips: [],
      fortune: this.fortuneFilterClick,
      unicorn: this.unicornFilterClick,
      search: this.searchValue

    }

  this.CompanyInsightsService.setCompanyFilterData(filterData);
   // this.getRecommendCompanies();
  }

  clearAll() {
    this.industrySelectedChips = [];
    this.locationSelectedChips = [];
    this.companySizesSelectedChips = [];
    this.fortuneFilterClick = false;
    const filterData = {
      industry: [],
      companysize: [],
      locations: [],
      fortune: false,
      unicorn: false,
      search: this.searchValue
    }
          this.setDataInLocalStorage();

 this.parentSubject.next({status: 'clearAll'});

  this.CompanyInsightsService.setCompanyFilterData(filterData);

  }

  getCompanyListData(response){
    this.industrySelectedChips = response.industry;
    this.companySizesSelectedChips = response.companysize;
    this.locationSelectedChips = response.locations;
    this.fortuneFilterClick = response.fortune;
    this.unicornFilterClick = response.unicorn;
    this.searchValue = response.search;
          this.setDataInLocalStorage();

  }

  showCleatAll() {
    return this.industrySelectedChips.length > 0 || this.companySizesSelectedChips.length > 0 || this.locationSelectedChips.length > 0 || this.fortuneFilterClick || this.unicornFilterClick;
  }
    setDataInLocalStorage(replace: boolean = false) {
    const filterData = {
      industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips : [],
      companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips : [],
      locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips : [],
      fortune: this.fortuneFilterClick,
      unicorn: this.unicornFilterClick,
      search: this.searchValue
    }
    const localKey = GlobalService.hash(JSON.stringify(cjson.compress(filterData)));
        if (!window.location.search.includes(localKey)) {

    localStorage.setItem(localKey, JSON.stringify(cjson.compress(filterData)));
    const parsedUrl = this.router.parseUrl(this.router.url);

    this.location[replace ? 'replaceState' : 'go'](parsedUrl.toString().split('?')[0], 'filter=' + encodeURIComponent(localKey));
        }
  }

    /**
   * Load filter data from local storage for managing the state on page refresh and browser back/forward
   * @param filterData
   */
  loadDataFromLocalStorage(filterData) {
    if (filterData && filterData.industry) {
      this.industrySelectedChips = filterData.industry;
      this.getFilterData('industry', '');
    } else {
      this.industrySelectedChips = [];
      this.getFilterData('industry', '');

    }

    if (filterData && filterData.companysize) {
      this.companySizesSelectedChips = filterData.companysize;
      this.getFilterData('companysize', '');

    } else {
      this.companySizesSelectedChips = [];
    }

    if (filterData && filterData.locations) {
      this.locationSelectedChips = filterData.locations;
      this.getFilterData('location', '');
    } else {
      this.locationSelectedChips = [];
      this.getFilterData('location', '');
    }

    if (filterData && filterData.fortune != undefined) {
      this.fortuneFilterClick = filterData.fortune;
    } else {
      this.fortuneFilterClick = true;
    }

    if (filterData && filterData.unicorn != undefined) {
      this.unicornFilterClick = filterData.unicorn;
    } else {
      this.unicornFilterClick = false;
    }

    if (filterData && filterData.search) {
      this.searchValue = filterData.search;
            this.CompanyInsightsService.setCompanySearschData(this.searchValue)

    } else {
      this.searchValue = null;
    }
    const filter = {
      industry: this.industrySelectedChips?.length > 0 ? this.industrySelectedChips : [],
      companysize: this.companySizesSelectedChips?.length > 0 ? this.companySizesSelectedChips : [],
      locations: this.locationSelectedChips?.length > 0 ? this.locationSelectedChips : [],
      fortune: this.fortuneFilterClick,
      unicorn: this.unicornFilterClick,
      search: this.searchValue
    }
    this.filterInput.emit(filter);
    //   this.CompanyInsightsService.setCompanyFilterData(filter);

  }

    private getFilterKeyFromUrl(): string | null {
    const params = new URLSearchParams(location.search);
    return params.get("filter");
  }

}
